module.exports = __webpack_public_path__ + "starfish.jpg?b2a9641b24ac6f3c60acb6d6e811fff4";